import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { cn } from '@/lib/utils';
import Icon from './Icon';
import ProgressBar from './ProgressBar';

interface CoverageMeterProps {
  /** e.g. "1-Year Accidental Damage Protection". */
  plan: string;
  /** e.g. "Covered till 18 Sep 2027". */
  till: string;
  /** e.g. "10m left". */
  left: string;
  /** Share of the cover period remaining, 0 to 1. */
  remaining: number;
  /** Optional small print, e.g. what's covered and the policy number. */
  note?: string;
  className?: string;
}

/** Active plan with its end date and time left (Figma "Coverage meter"). */
const CoverageMeter: React.FC<CoverageMeterProps> = ({ plan, till, left, remaining, note, className }) => (
  <div className={cn('tw-flex tw-w-full tw-flex-col tw-gap-2.5 tw-rounded-xl tw-bg-ds-subtle tw-p-[14px]', className)}>
    <div className="tw-flex tw-items-center tw-gap-2.5">
      <Icon icon={ShieldCheck} className="tw-text-ds-brand-text" />
      <p className="tw-min-w-0 tw-flex-1 tw-text-[14px] tw-font-semibold tw-leading-5 tw-text-ds-text-primary">{plan}</p>
    </div>
    <ProgressBar value={remaining} label="Cover period remaining" />
    <div className="tw-flex tw-items-start tw-justify-between tw-gap-3 tw-text-[13px] tw-leading-[18px]">
      <p className="tw-text-ds-text-secondary">{till}</p>
      <p className="tw-shrink-0 tw-font-semibold tw-text-ds-text-primary">{left}</p>
    </div>
    {note && <p className="tw-text-[12px] tw-leading-4 tw-text-ds-text-tertiary">{note}</p>}
  </div>
);

export default CoverageMeter;
